import { ldb } from '@codesuma/baseline'
import { prepareImport } from './rows'
import { importIntoIdb } from './idb'
import { importIntoSqlite } from './sqlite'

function source() {
    return {
        tasks: ldb.get('tasks'),
        events: ldb.get('events'),
        'custom-occasions': ldb.get('custom-occasions'),
    }
}

// Called after the engine is open and before the stores fill memory. Each
// engine checks its own flag first and skips any collection that already
// holds rows, so a second run cannot duplicate anything. The localStorage
// keys themselves are never written or deleted — they are the rollback. A
// throw here is caught by openStorage, which falls back to local for the
// session, so the next launch retries.
export async function runImport(engine: 'sqlite' | 'idb') {
    const prepared = prepareImport(source())
    if (engine === 'sqlite') return importIntoSqlite(prepared)
    return importIntoIdb(prepared)
}
